export default __webpack_public_path__ + "static/media/17955-harwoo.14ef3e17.pdf";